import moment from 'moment';

const date = function(value) {
  return moment(value).isValid();
};

const daterequired = function(value) {
  if (value) {
    return true;
  }else {
    return false;
  }

};

export { date, daterequired };
